import './_three-column.scss';

export default () => {};
